import { call, put, takeEvery } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import axios from 'axios';
import API from '../../API';

async function postApi(data) {
    const apiUrl = API.baseURL + `/providers/update.json`;
    try {
        const response = axios.put(apiUrl, data, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}

const getApiErrorMessage = (payload, fallback = "Unable to update profile. Please try again.") => {
    if (Array.isArray(payload?.errors) && payload.errors.length > 0) return payload.errors.join(", ");
    if (typeof payload?.errors === "string" && payload.errors.trim()) return payload.errors;
    if (Array.isArray(payload?.data?.errors) && payload.data.errors.length > 0) return payload.data.errors.join(", ");
    if (typeof payload?.data?.errors === "string" && payload.data.errors.trim()) return payload.data.errors;
    return payload?.error || payload?.message || payload?.data?.error || payload?.data?.message || fallback;
};

function* updateProfile(action) {
    try {
        const response = yield call(postApi, action.data);
        if (response.status == 200 || response.status == 201) {
            // toastr.success('Success', 'Updated profile successfully');
        } else {
            // response.errors.length != 0 && toastr.error('Failed to update', response.errors[0]);
        }
        yield put({ type: 'POST_UPDATE_PROFILE_SUCCESS', data: response.data });
        yield put({ type: 'GET_PROFILE_DATA_REQUESTED', data: response.data });
        location.reload();
    } catch (e) {
        const errorMessage = getApiErrorMessage(e?.response?.data, e.message);
        toastr.error('Update Failed', errorMessage);
        yield put({ type: 'POST_UPDATE_PROFILE_FAILED', message: errorMessage });
    }
}

function* updateProfileSaga() {
    yield takeEvery('POST_UPDATE_PROFILE_REQUESTED', updateProfile);
}

export default updateProfileSaga;
